import '@content/foundations/src'
import asWebComponent from '../../../asWebComponent.ts'
import Faq from '@components/member-get-member/mgm-faq-v2/MgmFaq.tsx'

export default asWebComponent(Faq, 'nb-mgm-faq-v2', ['data'])
